import { FC } from 'react';

import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { UpsellCard } from '../../_components/UpsellCard';

export type LayoutNoSubscriptionProps = {
  t: TypeAccountERCTranslations;
  subscriptionId: string;
};

const LayoutCancelledSubscription: FC<LayoutNoSubscriptionProps> = ({
  t,
  subscriptionId,
}) => (
  <div
    data-testid="layout-cancelled-subscription"
    className="text-center px-6 md:px-8"
  >
    <HeaderText
      classes="text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] pb-6"
      size={HeaderSize.H1}
      align="left"
      text={t.cancelledSubscriptionTitle}
    />

    <UpsellCard
      headerText={t.cancelledSubscriptionCardTitle}
      subText={t.cancelledSubscriptionCardSubText}
      ctaText={t.cancelledSubscriptionCtaText}
      ctaLink={`/account/early-reader-club/${subscriptionId}/reactivate`}
    />
  </div>
);

export default LayoutCancelledSubscription;
